import { Modal, message } from 'antd';
import React, { FC } from 'react';
import { getProductId } from '@/infrastructure/product-info';
import { TapdParams } from '@/presentation/components/tapd-info';
import { releaseTapdIssue } from '@/presentation/components/tapd-info/api';
import { getTypeByZone } from '@/proto/issue';

interface IProps {
  visible: boolean;
  releaseParams: TapdParams;
  onHide: () => void;
  onSubmit: () => void;
}

/**
 * 取消关联tapd组件
 */

export const ReleaseTapdModal: FC<IProps> = (props) => {
  const { visible, releaseParams, onHide, onSubmit } = props;
  const deleteTapd = async () => {
    const succ = await releaseTapdIssue({
      productId: getProductId(),
      type: getTypeByZone(releaseParams.type),
      issueKey: releaseParams.issueKey,
    });
    if (succ) {
      message.success('取消关联成功');
    } else {
      message.error('取消关联失败');
      return;
    }
    onSubmit();
    onHide();
  };
  return (<Modal
      centered
      title='取消关联确认'
      visible={visible}
      onOk={() => deleteTapd()}
      onCancel={() => onHide()}
    >
      你确认要取消此问题与缺陷的关联吗？
    </Modal>
  );
};
